import { ColorModel } from '../models';

export const orderValuesBeforeNulls = (
  a: string | number | null,
  b: string | number | null
): number => {
  const aInvalid = a === null || Number.isNaN(a);
  const bInvalid = b === null || Number.isNaN(b);

  if (aInvalid || bInvalid) {
    if (aInvalid && bInvalid) {
      return 0;
    }

    return aInvalid ? 1 : -1;
  }

  return a < b ? -1 : a > b ? 1 : 0;
};

/**
 * get the default color from a list using lowest ranked color
 * @param colors
 */
export const selecteDefaultColor = (colors: ColorModel[]) => {
  const rankedColors = colors.toSorted((a, b) =>
    orderValuesBeforeNulls(a.rank ?? null, b.rank ?? null)
  );

  return rankedColors[0];
};

/**
 * find tbe best matching color by the following priority order
 *  1. exact productId match (common when the color list didn't actually change)
 *  2. matching masterSku
 *  3. matching name and thickness
 *  4. matching name
 *  5. default color from the color list - first color in ranked order
 * @param color the current color we want to match for
 * @param colors
 */
export const selectBestMatchingColor = (
  color: Partial<ColorModel> | undefined,
  colors: ColorModel[],
  restorableColor?: ColorModel | undefined
): ColorModel | undefined => {
  if (!color) {
    return selecteDefaultColor(colors);
  }
  const colorByProductId = colors.find(
    (testColor) => testColor.productId === color.productId
  );
  const colorBySku = colors.find(
    (testColor) => testColor.masterSku === color.masterSku
  );
  const colorByNameAndThickness = colors.find(
    (testColor) =>
      testColor.name === color.name && testColor.thickness === color.thickness
  );
  const colorByName = colors.find((testColor) => testColor.name === color.name);
  const colorByRestorable = restorableColor
    ? colors.find(
        (testColor) => testColor.productId === restorableColor.productId
      )
    : undefined;

  return (
    colorByProductId ??
    colorByRestorable ??
    colorBySku ??
    colorByNameAndThickness ??
    colorByName ??
    selecteDefaultColor(colors)
  );
};
